import React from 'react';

import colorsVars from 'styles/colors.module.scss';

import classes from 'components/common/Avatar/Avatar.module.scss';
import { getAvatarColor, getInitials } from 'components/common/Avatar/Avatar.utils';
import { MuiIcon } from 'components/common/muiIcon/muiIcon';

const { white } = colorsVars;
interface IAvatarProps {
    fullName: string;
    isUnassigned?: boolean;
    className: string;
}

export const Avatar = ({ fullName, isUnassigned = false, className = '' }: IAvatarProps) => (
    <span
        className={`${classes.avatar} ${isUnassigned ? classes.unAssigned : classes[getAvatarColor(fullName.trim())]} ${className}`}
        data-testid="avatar"
    >
        {isUnassigned ? <MuiIcon icon={'person'} fontSize={'2.4rem'} color={white} /> : getInitials(fullName.trim())}
    </span>
);
